import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router'

import { BcCircleLoadingComponent } from '@bancolombia/design-system-web/bc-circle-loading';
import { BcInputFileComponent } from '@bancolombia/design-system-web/bc-input-file';
import { ErrorModel } from 'src/app/domain/models/error/error.model';
import { Adjuntos, FacturaContentModel, FacturaTax } from 'src/app/domain/models/factura/factura.model';
import { AppModalUseCase } from 'src/app/domain/usecases/app-modal/app-modal.usecase';
import { ArchivoAdjuntoUseCase } from 'src/app/domain/usecases/archivo-adjunto/archivo-adjunto.usecase';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';

@Component({
  selector: 'app-factura',
  templateUrl: './factura-detalle.component.html',
  styleUrls: ['./factura-detalle.component.css']
})
export class FacturaDetalleComponent implements OnInit {

  @ViewChild('loadingCircleFacturaDetalle', { static: false })
  bcCircleLoading!: BcCircleLoadingComponent;

  @ViewChild('InputFileDetalleFactura')
  inputInstace!: BcInputFileComponent;

  titulo: string = 'Detalle de factura';
  numeroFactura: string = ''
  dataFactura: FacturaContentModel = {
    numero_factura: '',
    ciudad: null,
    remitente: '',
    nit: '',
    fecha_creacion: new Date(),
    estado: {
      nombre: '',
      codigo: ''
    },
    retieca: '',
    reteiva: '',
    retefuente: '',
    total_acticipos: 0,
    iva: '',
    total_antes_impuestos: 0,
    total_incl_impuestos: 0,
    razons_adquiriente: '',
    nit_adquiriente: '',
    ciuAdquiriente: '',
    depEmision: ''
  };

  /* Modal */
  isModal: boolean = false;
  titleModal: string = ''
  typeIconModal: any = ''
  bodyModal: string = ''
  subBodyModal: string = ''
  /* End Modal */

  /* Circle Loading */
  circleLoadingText = "Consultando...";
  circleLoadingAriaLabel = "";
  loaderSpeed = "0.5";
  /* End Circle Loading */

  /* Taxes Block */
  taxesBlock = [{
    code: '05',
    desc: 'Retención IVA'
  }, {
    code: '06',
    desc: 'Retefuente'
  }, {
    code: '07',
    desc: 'Retención ICA'
  }]
  /* Taxes Block */



  constructor(
    private facturaUseCase: FacturaUseCase,
    private route: ActivatedRoute,
    private appModalUseCase: AppModalUseCase) {
  }

  ngOnInit() {
    this.numeroFactura = this.route.snapshot.paramMap.get('numero')!;
  }

  ngAfterViewInit() {
    this.consultarFactura();
  }

  

  consultarFactura() {
    this.bcCircleLoading.showCircleLoading();
    this.facturaUseCase.findByNumero(this.numeroFactura)
      .subscribe({
        next: data => {
          this.dataFactura = data;
          this.bcCircleLoading.hideCircleLoading();
        },
        error: error => {
          this.bcCircleLoading.hideCircleLoading();
          this.modalFindErrorMessages();
          this.isModal = true;
        }
      });
  }

  modalFindErrorMessages(): void {
    const [titleModal, typeIconModal, bodyModal, subBodyModal] = this.appModalUseCase.modalFindErrorMessages();
    this.titleModal = titleModal;
    this.typeIconModal = typeIconModal;
    this.bodyModal = bodyModal;
    this.subBodyModal = subBodyModal;
  }

  obtenerIva(data: FacturaContentModel): number {
    let valorIva = 0;
    data.tax?.map((tax: FacturaTax) => {
      if (tax.tipo.code == '01') {
        valorIva = tax.amount
      }
    })
    return valorIva;
  }

  identificarValortax(codigoTax: string, tax?: FacturaTax[]): number {
    let response: number = 0;
    tax?.forEach((datoTax: FacturaTax) => {
      if (datoTax.tipo.code == codigoTax) {
        response = datoTax.amount;
      }
    });
    return response;
  }

}
